class EsaedroResourceFilter {
   
    private _FieldName: string = "";
    public get FieldName() : string { return this._FieldName }   
    public set FieldName( newvalue: string ) { this._FieldName = newvalue }

    private _Value: any;
    public get Value() : any { return this._Value }   
    public set Value(newvalue: any) { this._Value = newvalue }

    private _Operator: string = "";
    public get Operator() : any { return this._Operator }    
    public set Operator(newoperator: any) { this._Operator = newoperator }

    private _previousFilterOperator: string = "";
    public get previousFilterOperator() : any { return this._previousFilterOperator }   
    public set previousFilterOperator(newPreviousFilterOperator: any) { this._previousFilterOperator = newPreviousFilterOperator }

    private _description: string = "";
    public get description() : any { return this._description }   
    public set description(newdescription: any) { this._description = newdescription}

    private _filterType: string = "text";
    public get filterType() : any { return this._filterType } 
    public set filterType(newfilterType: any) {  this._filterType = newfilterType }

    constructor(field:string, value:string, operator: string, description?: string, filterType?: string) {
        this.FieldName=field
        this.Value=value
        this.Operator=operator
        this.description=description?description:field
        this._filterType=filterType?filterType:"text"
    }

}

export default EsaedroResourceFilter;